import * as React from 'react'
import { useMemo } from 'react'

import { inject, observer } from 'mobx-react'

import WorkflowViewFormWrapper from '~/client/src/shared/components/SitePermitCreationForm/WorkflowViewFormWrapper'
import useWorkflowById from '~/client/src/shared/hooks/useWorkflowById'
import Workflow from '~/client/src/shared/models/Workflow'

import DesktopFileInput from '../../../components/FileInput/DesktopFileInput'
import DesktopEventStore from '../../../stores/EventStore/DesktopEvents.store'
import NotificationDetailsBase from './NotificationDetailsBase/NotificationDetailsBase'

interface IProps {
  backClicked: () => void

  permitId?: string
  associatedPermit?: Workflow

  eventsStore?: DesktopEventStore
}

const NotificationDetailsPermitComponent: React.FC<IProps> = ({
  permitId,
  backClicked,
  eventsStore,
  associatedPermit,
}) => {
  const { workflow: queriedWorkflow } = useWorkflowById(
    eventsStore.appState.activeProject.id,
    permitId,
  )

  const workflow = useMemo(
    () => associatedPermit || queriedWorkflow,
    [associatedPermit, queriedWorkflow],
  )

  const renderContent = () => {
    if (!workflow) {
      return null
    }
    return (
      <WorkflowViewFormWrapper
        key={workflow.id}
        workflowToShow={workflow}
        onClose={backClicked}
        FileInputType={DesktopFileInput}
      />
    )
  }

  return (
    <NotificationDetailsBase
      backClicked={backClicked}
      content={renderContent()}
    />
  )
}

const NotificationDetailsPermit = inject('eventsStore')(
  observer(NotificationDetailsPermitComponent),
)

export default NotificationDetailsPermit
